import React from 'react';
import { ThemeProvider } from './src/contexts/ThemeContext';
import { captureAttribution } from './src/utils/attribution';
import 'prismjs/themes/prism-tomorrow.css';
// 서체는 자체 호스팅한다(디자인 결정 D9). 한글·본문은 Pretendard(필요한 글자만 내려받는 동적 서브셋),
// 영문 제목·숫자는 Space Grotesk, 라벨·숫자 모노는 IBM Plex Mono — 쓰는 굵기만 불러온다.
import 'pretendard/dist/web/variable/pretendardvariable-dynamic-subset.css';
import '@fontsource/space-grotesk/500';
import '@fontsource/space-grotesk/600';
import '@fontsource/space-grotesk/700';
import '@fontsource/ibm-plex-mono/400';
import '@fontsource/ibm-plex-mono/500';

export const onClientEntry = () => {
  captureAttribution();
};

export const wrapRootElement = ({ element }) => {
  return <ThemeProvider>{element}</ThemeProvider>;
};
